import { createApp } from 'vue'
import store from '@/Stores'

import App from '@/App.vue'
import router from '@/Router'

createApp(App).use(router).use(store).mount('#app')
